const membershipFaqs = [
  {
    q: "Do you offer a trial session?",
    a: "Yes — contact us to arrange a trial session before committing to a membership plan.",
  },
  {
    q: "Can I pause or freeze my membership?",
    a: "Freeze policies vary by plan. Speak to the front desk team for the current policy.",
  },
  {
    q: "Is personal training included in every plan?",
    a: "Personal training sessions are included from the Quarterly plan upward. See the comparison table above.",
  },
  {
    q: "What are the gym timings?",
    a: "Timings shown on the Contact page are placeholders pending confirmation — please call ahead to confirm current hours.",
  },
];

export default membershipFaqs;
